import { render, staticRenderFns } from "./CustomerApply.vue?vue&type=template&id=385c5b4d&scoped=true&"
import script from "./CustomerApply.vue?vue&type=script&lang=js&"
export * from "./CustomerApply.vue?vue&type=script&lang=js&"
import style0 from "./CustomerApply.vue?vue&type=style&index=0&id=385c5b4d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385c5b4d",
  null
  
)

export default component.exports